var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66732 11.3337C1.30065 11.3337 0.986762 11.2031 0.725651 10.942C0.46454 10.6809 0.333984 10.367 0.333984 10.0003V2.00033C0.333984 1.63366 0.46454 1.31977 0.725651 1.05866C0.986762 0.797548 1.30065 0.666992 1.66732 0.666992H12.334C12.7007 0.666992 13.0145 0.797548 13.2757 1.05866C13.5368 1.31977 13.6673 1.63366 13.6673 2.00033V10.0003C13.6673 10.367 13.5368 10.6809 13.2757 10.942C13.0145 11.2031 12.7007 11.3337 12.334 11.3337H1.66732ZM7.00065 6.66699L1.66732 3.33366V10.0003H12.334V3.33366L7.00065 6.66699ZM7.00065 5.33366L12.334 2.00033H1.66732L7.00065 5.33366ZM1.66732 3.33366V2.00033V10.0003V3.33366Z",
    fill: "#A9A9C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a6c2f9ac67dccc64aeff2761722ad264.svg";
export { ForwardRef as ReactComponent };